// extracted by mini-css-extract-plugin
module.exports = {"header":"ReferencesLinks_header__kHFaA","link":"ReferencesLinks_link__13Tp8"};